import { Badges } from './Badges';

export { useBadgesRenderer } from './hooks';

export default Badges;
